import * as React from "react";
import styled from "styled-components";
import useNavigationCustomization from "brand-customization/useNavigationCustomization";
import { Icon, Sanitize } from "components/common";
import { MAX_NAV_ICON_WIDTH } from "theme/constants";
const DEFAULT_ICONS = {
  "home": "home",
  "scratchpad": "edit_square",
  "user_menu": "person",
  "help": "help",
  "search": "search"
};
const SvgContainer = styled.div`
  svg {
    width: 100%;
    max-width: ${MAX_NAV_ICON_WIDTH};
    height: 22px;
    display: block;
    fill: currentColor;
  }
`;
const useCustomIcon = (type) => {
  var _a, _b;
  const navigationCustomization = useNavigationCustomization();
  return (_b = (_a = navigationCustomization == null ? void 0 : navigationCustomization[type]) == null ? void 0 : _a.icon) != null ? _b : null;
};
const NavIcon = ({ type, title = void 0 }) => {
  const customSvgIcon = useCustomIcon(type);
  if (customSvgIcon) {
    return /* @__PURE__ */ React.createElement(SvgContainer, { title }, /* @__PURE__ */ React.createElement(Sanitize, { html: customSvgIcon }));
  }
  return /* @__PURE__ */ React.createElement(Icon, { name: DEFAULT_ICONS[type], size: "lg", title });
};
export default NavIcon;
